module.exports = __webpack_public_path__ + "img/122.4f53b868.jpg";